var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8524 0.397737C15.5872 0.132569 15.2684 0 14.8961 0H1.35418C0.981787 0 0.663082 0.132539 0.397737 0.397737C0.132539 0.662963 0 0.981669 0 1.35409V11.6458C0 12.0183 0.132539 12.337 0.397737 12.6022C0.663082 12.8674 0.981787 13 1.35418 13H14.8961C15.2684 13 15.5872 12.8674 15.8524 12.6022C16.1175 12.337 16.2503 12.0183 16.2503 11.6458V1.35409C16.2503 0.981669 16.1175 0.662963 15.8524 0.397737ZM15.1668 11.646C15.1668 11.7194 15.14 11.7827 15.0864 11.8365C15.0329 11.8899 14.9694 11.9166 14.8961 11.9166H1.35418C1.28087 11.9166 1.21737 11.8899 1.16377 11.8363C1.11021 11.7825 1.08338 11.7192 1.08338 11.6458V6.5H15.1668V11.646H15.1668ZM15.1668 3.24984H1.08335V1.35397C1.08335 1.28063 1.11009 1.21728 1.16374 1.16357C1.21737 1.11012 1.28087 1.08329 1.35415 1.08329H14.8961C14.9693 1.08329 15.0328 1.11 15.0864 1.16357C15.14 1.21728 15.1668 1.28063 15.1668 1.35397V3.24984H15.1668Z",
    fill: "#C5C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33354 9.75049H2.16687V10.8339H4.33354V9.75049Z",
    fill: "#C5C5C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66713 9.75049H5.41711V10.8339H8.66713V9.75049Z",
    fill: "#C5C5C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.566c1e52cdf571ef67e0f2a8caf8c190.svg";
export { ForwardRef as ReactComponent };